import API from '@/services/endpoint'
import { FETCH_EVENTS_LIST } from "../../mutation-types";

/**
 * API Get Request to fetch the events images
 * @param {function} commit - The vuex commit function
 * @param {object} state - The vuex state object
 * @param id
 * @return {object[]} A array of events
 */
export async function fetchEvents({commit, state}, id) {
  const { url } = state;
  let responseObj = await API.get(`${url}/${id}`);
  let { data: { message: { events } } } = responseObj;
  commit(FETCH_EVENTS_LIST, events)
}
